import uri from 'urijs';
import createAction from '../services/create-action';
import { createThunk } from '../services/create-thunk';
import { buildPaginationRequestParams } from '../services/pagination';

export const FETCH_USER_POSTS_REQUEST = 'userPosts/FETCH_REQUEST';
export const FETCH_USER_POSTS_SUCCESS = 'userPosts/FETCH_SUCCESS';
export const FETCH_USER_POSTS_FAILURE = 'userPosts/FETCH_FAILURE';

export const fetchProfilePostsRequest = createAction(FETCH_USER_POSTS_REQUEST);
export const fetchProfilePostsSuccess = createAction(
  FETCH_USER_POSTS_SUCCESS,
  payload => payload,
  (payload, meta) => meta
);
export const fetchProfilePostsFailure = createAction(FETCH_USER_POSTS_FAILURE);

export default function fetchPostsByOwnerId({ ownerId, page, pageSize }) {
  return createThunk((dispatch, getState, { request }) => {
    dispatch(fetchProfilePostsRequest({ ownerId }));

    const params = buildPaginationRequestParams(page, pageSize);
    return request(uri(`/_api/posts/owner/${ownerId}`).query(params), { parseHeaders: true })
      .then(({ body = [], headers = {} }) =>
        dispatch(
          fetchProfilePostsSuccess(body, {
            page,
            entityCount: parseInt(headers.get('Wix-Forum-TotalResults'), 10),
          })
        )
      )
      .catch(() => dispatch(fetchProfilePostsFailure({ ownerId })));
  });
}



// WEBPACK FOOTER //
// ./app/actions/fetch-posts-by-owner-id.js